export default __webpack_public_path__ + "static/media/illustration3-min.e4c0d4e9.webp";